import React, { useEffect, useState } from 'react'
import "../styles/about.css"
import obj from "../svgs/object.svg"
import { useImages } from '../contexts/imageContext'
import { useAbout } from '../contexts/aboutContext'

export default function About() {
  const [images, setImage] = useImages()
  const [, about, skills] = useAbout()
  return (
      <section className="about mb-5" id="about">
          <small className='sub-head text-uppercase fw-bold mt-5 mt-md-0'>Who I am</small>
          <h3 className="display-5 mt-4 fw-bold text-uppercase">About me</h3>
          <div className="d-flex about-details justify-content-between align-items-center">
            <div className="about-text mt-4">
              <div  dangerouslySetInnerHTML={{__html: about}}></div>
              <div className="skills">
                <small className='text-uppercase fw-bold'>here are some of the technologies i'm fluent with:</small>
                <ul className="skill-list">
                  {skills.map((skill, id) => {
                    return <li key={id} className="text-capitalize">{skill}</li>
                  })}
                </ul>
              </div>
            </div>
              
              <div className="about-img px-5 mt-4 my-md-0">
                <img src={obj} className="obj" alt="" />
                <div className="me">
                  <img src={images && images.aboutImage} alt="developer"/>
                </div>
            </div>
          </div>
          
      </section>
  )
}
